<template>
  <v-snackbar
    v-model="isOpen"
    v-bind="$attrs"
    multi-line
    :timeout="-1"
    bottom
    right
    v-on="$listeners"
  >
    {{ $t('versionSnackbar.refreshMessage') }}
    <template #action="{attrs}">
      <v-btn v-bind="attrs" color="secondary" @click="refreshWindow">
        {{ $t('refresh') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import {defineComponent, ref, watch} from '@vue/composition-api';
import {useVersionCheckService} from '@/versioning/services/VersionCheckService';

export default defineComponent({
  name: 'SVersionSnackbar',
  setup() {
    const versionService = useVersionCheckService();
    const isOpen = ref(false);
    const refreshWindow = () => {
      window.location.reload();
    };
    watch(
      () => versionService.isUpToDate,
      (newValue) => {
        // Check for false because newValue may be null
        if (newValue === false) {
          isOpen.value = true;
        }
      }
    );

    return {isOpen, refreshWindow};
  },
});
</script>
